goog.provide("shadow.js.shim.module$src$svg$inform$lightbulb_fill_svg");
goog.provide("module$shadow_js_shim_module$src$svg$inform$lightbulb_fill_svg");
shadow.js.shim.module$src$svg$inform$lightbulb_fill_svg = shadow.js.nativeProvides["src/svg/inform/lightbulb-fill.svg"] = shadow$bridge("src/svg/inform/lightbulb-fill.svg");
module$shadow_js_shim_module$src$svg$inform$lightbulb_fill_svg.default = shadow.js.shim.module$src$svg$inform$lightbulb_fill_svg;
